module.exports = __webpack_public_path__ + "gold_badge.webp";